import { useState, useEffect } from 'preact/compat'

export default function useTouchedFields(watch, isPCIEnabled) {
  const [submittedData, setSubmittedData] = useState({})
  const [hasBeenTouchedAfterSubmit, setTouchedAfterSubmit] = useState(false)

  useEffect(() => {
    if (!isPCIEnabled) {
      const subscription = watch((value, { name }) => {
        if (
          Object.values(submittedData).length &&
          submittedData[name] !== value[name]
        ) {
          setTouchedAfterSubmit(true)
        }
      })

      return () => subscription.unsubscribe()
    }
  }, [watch, submittedData])

  return { hasBeenTouchedAfterSubmit, setTouchedAfterSubmit, setSubmittedData }
}
